<div class="mb-3">
  <div class="section-banner">
    <i class="bx bx-shield-quarter"></i>
    <span>Factores de Riesgo ({{ riskAssessments().length }})</span>
  </div>
  <div class="section-banner-body">
    @for (risk of riskAssessments(); track risk.id; let idx = $index) {
      @let statusBadge = getStatusBadge(risk.status || '');

      <div class="d-flex align-items-center justify-content-between mb-3">
        <div class="d-flex align-items-center gap-2">
          <span
            class="badge bg-secondary rounded-circle"
            style="
              width: 32px;
              height: 32px;
              display: flex;
              align-items: center;
              justify-content: center;
            "
          >
            #{{ idx + 1 }}
          </span>
          <strong>{{ getRiskName(risk) }}</strong>
        </div>
        @if (risk.status) {
          <span class="badge {{ statusBadge.color }} px-3 py-2">
            <i class="bx bx-check-circle"></i> {{ statusBadge.label }}
          </span>
        }
      </div>

      @if (risk.code?.coding?.[0]?.code) {
        <p class="mb-2">
          <strong>Código (FactorRiesgo):</strong>
          <span class="text-danger">{{ risk.code.coding[0].code }}</span>
        </p>
      }
      @if (getMitigation(risk)) {
        <p class="mb-2"><strong>Descripción:</strong> {{ getMitigation(risk) }}</p>
      }

      @if (!$last) {
        <hr />
      }
    }
  </div>
</div>
<hr />
